import { ActionItemType } from '@/types/schema';

// Dev TODO: use these everywhere in the codebase
class TaskEntity {
  static isRootTask(data: Pick<ActionItemType, 'parentId'>): boolean {
    return data.parentId == null;
  }
}

export default TaskEntity;
